module.exports = __webpack_public_path__ + "assets/check-box.e19005ccfc970807d15c7830a90984e8.svg";